import { render } from "./plus-lg.vue?vue&type=template&id=59d34e14"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/plus-lg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59d34e14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59d34e14', __exports__)) {
    api.reload('59d34e14', __exports__)
  }
  
  module.hot.accept("./plus-lg.vue?vue&type=template&id=59d34e14", () => {
    api.rerender('59d34e14', render)
  })

}


export default __exports__